import { useLocation } from "react-router"
import { useOrigin } from "../contexts/OriginContext"

export function useCurrentHref() {
  const { origin } = useOrigin()
  const { pathname, hash, search } = useLocation()

  return new URL(pathname + hash + search, origin).href
}
